// client/src/components/SortingControl.js
import React from 'react';

// Base sorting options available in all contexts
export const baseSortOptions = [
    { key: 'current_price', label: 'Aktueller Preis' },
    { key: 'market_cap', label: 'Marktkapitalisierung' },
    { key: 'dividend_yield', label: 'Dividendenrendite' },
    { key: 'trailing_p_e', label: 'KGV' },
    { key: 'forward_p_e', label: 'KGV erwartet' },
    { key: 'price_to_book', label: 'KBV' },
    { key: 'profit_margin', label: 'Gewinnmarge' },
    { key: 'operating_margin', label: 'Operative Marge' },
    { key: 'next_year_growth', label: 'Erw. Wachstum (Jahr)' },
    { key: 'revenue_growth', label: 'Umsatzwachstum' },
    { key: 'earnings_growth', label: 'Gewinnwachstum' },
    { key: 'daily_change', label: '24h Änderung' },
    { key: 'weekly_change', label: '7d Änderung' },
    { key: 'monthly_change', label: '30d Änderung' },
    { key: 'yearly_change', label: '1J Änderung' }
];

// Portfolio-specific sorting options
export const portfolioSortOptions = [
    { key: 'value', label: 'Gesamtwert' },
    { key: 'total_growth', label: 'Gesamtwachstum' }
];

// Combined options for use in portfolio views
export const allSortOptions = [...baseSortOptions, ...portfolioSortOptions];

const SortingControl = ({ sortBy, onSortChange, sortOrder, onSortOrderChange, context = 'all' }) => {
    // Determine which options to display based on context
    const options = context === 'search' ? baseSortOptions : allSortOptions;
    
    return (
        <div className="sort-group">
            <select 
                className="modern-input sort-select"
                value={sortBy}
                onChange={(e) => onSortChange(e.target.value)}
                aria-label="Sortieren nach"
            >
                <option value="" disabled>Sortieren nach...</option>
                {options.map(option => (
                    <option key={option.key} value={option.key}>
                        {option.label}
                    </option>
                ))}
            </select>
            <button 
                type="button"
                className="sort-direction-button"
                onClick={() => onSortOrderChange(order => order === 'asc' ? 'desc' : 'asc')}
                title={sortOrder === 'asc' ? 'Aufsteigend sortiert' : 'Absteigend sortiert'}
                aria-label={sortOrder === 'asc' ? 'Aufsteigend sortiert, auf absteigend wechseln' : 'Absteigend sortiert, auf aufsteigend wechseln'}
            >
                <i className={`fas fa-sort-amount-${sortOrder === 'asc' ? 'up-alt' : 'down'}`} aria-hidden="true" />
            </button>
        </div>
    );
};

export default SortingControl;